import { Component } from "react";
import { navigateTo } from "../js/auth";

class AbstractMenuItem extends Component {
  pushMenu() {
    return this.props.pushMenu();
  }
  back() {
    this.props.back();
  }
  navigate(url) {
    // eslint-disable-next-line no-restricted-globals
    navigateTo(url);
  }
  setParentState(state) {
    this.props.setParentState(state);
  }
}

export default AbstractMenuItem;
